<div class="input">
    <div class="position-wrapper">
        <img src="/content/icons/Magnifier.svg" class="input-icon-magnifier">
        <input autocorrect="off" autocapitalize="off" spellcheck="off" [placeholder]="'Enter location' | translate" [formControl]="locationControl" (blur)="onBlur()" #searchElement [ngClass]="invalid ? 'invalid' : locationControl.value && !locationSetByGoogle ? 'not-set-by-google' : ''">
    </div>
</div>
